import { cleanObject, isEmptyObject, parseJsonStringSafely } from '@teko/utils';
import { Filter, FilterOption } from '@teko/types/ecommerce';
import { BUILDPC_V3_LOCAL_STORAGE_KEY } from '../constants/buildpc';
import { ILSBuildPCData } from 'types';

export const getDisplayFilter = (filters: Filter[]) => {
  return filters.filter(
    (filter) => filter?.options?.length && filter.options.length > 1,
  );
};

export const convertFilter = (filters: FilterOption[]) => {
  const convertedFilters: { [key: string]: Array<unknown> } = {};
  const attributes = new Map<string, string[]>();
  filters.forEach((filter) => {
    if (filter.filterCode && filter.optionId) {
      // attributes
      if (filter.filterCode.startsWith('attributes.')) {
        const attributeCode = filter.filterCode.replace('attributes.', '');
        const attributesValue = attributes.get(attributeCode);
        if (attributesValue) {
          attributes.set(attributeCode, [
            ...attributesValue,
            filter.optionId.toString(),
          ]);
        } else {
          attributes.set(attributeCode, [filter.optionId.toString()]);
        }
        // others
      } else {
        const attributesValue = convertedFilters[filter.filterCode];
        if (attributesValue) {
          convertedFilters[filter.filterCode] = [
            ...attributesValue,
            filter.optionId.toString(),
          ];
        } else {
          convertedFilters[filter.filterCode] = [filter.optionId.toString()];
        }
      }
    }
  });
  if (attributes.size > 0) {
    convertedFilters['attributes'] = Array.from(
      attributes,
      ([code, optionIds]) => ({ code, optionIds }),
    );
  }
  return cleanObject(convertedFilters);
};

export const getLocalConfigs = (): ILSBuildPCData => {
  let result: ILSBuildPCData = {
    configs: [{}, {}, {}],
    activeIndex: 0,
  };
  const lsBuildPcLocalConfigs: string | null =
    typeof window !== 'undefined'
      ? localStorage.getItem(BUILDPC_V3_LOCAL_STORAGE_KEY)
      : null;

  if (
    !!lsBuildPcLocalConfigs &&
    !isEmptyObject(
      parseJsonStringSafely(lsBuildPcLocalConfigs) as ILSBuildPCData,
    )
  ) {
    result = parseJsonStringSafely(lsBuildPcLocalConfigs) as ILSBuildPCData;
  }

  return result;
};
